<CDMS-Portal-U2-common-confirmation-modal-control
  [modalType]="'confirm'"
  [showDialog]="true"
  [bodyText]="'This action will lose your unsaved changes, do you want to continue?'"
  (closeEvent)="onConfirmationSelect(false)"
  (affirmEvent)="onConfirmationSelect(true)"
  (denyEvent)="onConfirmationSelect(false)">
</CDMS-Portal-U2-common-confirmation-modal-control>